import $ from 'jquery';

var messageBoxRequest = {
    message: "",
    supplierId: "",
    customerId: ""
};

var supplierId = 0;
var customerId = 0;

function showMessageBoxModal(messages) {
  const modal = document.querySelector('#messageBoxModal');
  let modalObj = bootstrap.Modal.getOrCreateInstance(modal);
  modalObj.show();

  displayMessages(messages);
}

function displayMessages(messageBox) {
    const messageBoxHistory = $("#messageBoxHistory");
    //remove all html content
    messageBoxHistory.html("");

    if (!messageBox || messageBox.messageBoxDetails.length === 0) {
        $("#sendMessageBoxBtn").removeClass("d-none");
        $("#SupplierResponseMessage").addClass("d-none");
        return;
    }

    const lastMessage = messageBox.messageBoxDetails[messageBox.messageBoxDetails.length - 1];

    if (lastMessage && !lastMessage.approved && !lastMessage.seen) {
        $("#sendMessageBoxBtn").addClass("d-none");
        $("#SupplierResponseMessage").removeClass("d-none");
    } else {
        $("#sendMessageBoxBtn").removeClass("d-none");
        $("#SupplierResponseMessage").addClass("d-none");
    }

    const messagesList = messageBox.messageBoxDetails

    messagesList.forEach(function(m) {
        const alignClass = m.senderId === messageBox.userCustomerId ? "text-end" : "text-start";
        const bgClass = m.senderId === messageBox.userCustomerId ? "bg-primary text-white" : "bg-light";

        const dateSplit = m.createdAt.split("T");

        const messageElement = $("<div class='message-item mb-2 p-2 border rounded " + bgClass + " " + alignClass + "'>");
        messageElement.append($("<p class='mb-1'>").text(m.message));
        messageElement.append($("<small>").text(dateSplit[0] + " " + dateSplit[1].substring(0, 5)));
        messageBoxHistory.append(messageElement);
    });
}

function loadMessageBox(callback) {
    $.ajax({
        url: '/api/MessageBox',
        type: 'GET',
        data: {
            supplierId: supplierId,
            customerId: customerId
        },
        success: function (response) {
            messageBoxRequest.supplierId = supplierId;
            messageBoxRequest.customerId = customerId;

            if (callback) {
                callback(response);
            } else {
                showMessageBoxModal(response);
            }
        },
        error: function () {
            alert("Error al procesar la solicitud.");
        }
    });
}

function sendMessage() {
    $.ajax({
        url: '/api/MessageBox',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(messageBoxRequest),
        success: function (_) {
            $("#messageBoxText").val("");
            loadMessageBox(displayMessages);
        },
        error: function () {
            alert("Error al procesar la solicitud.");
        }
    });
}

$(document).ready(function () {
    var messageBoxBtn = $(".message-box-btn");
    var sendMessageBoxBtn = $("#sendMessageBoxBtn");
    var messageBoxSupplierName = $("#messageBoxSupplierName");

    //send message to supplier
    sendMessageBoxBtn.on("click", function () {
        var message = $("#messageBoxText").val().trim();
        if (!message) {
            alert("El mensaje no puede estar vacío.");
            return;
        }

        messageBoxRequest.message = message;

        sendMessage();
    });

    //load message box history (open modal)
    messageBoxBtn.on("click", function () {
        supplierId = $(this).data('supplierid');
        customerId = $(this).data('customerid');
        var supplierName = $(this).data('suppliername');
        
        messageBoxSupplierName.text(supplierName);

        loadMessageBox();
    });
});